import { PLATFORM_OPTIONS } from '../constants';
import { PlatformOptionRow } from './platform-option-row';

export function PlatformOptionList({
  value,
  disabledFor,
  onSelect,
}: {
  value: string;
  disabledFor: (key: string) => boolean;
  onSelect: (key: string) => void;
}) {
  return (
    <div className="divide-y divide-gray-200 overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm">
      {PLATFORM_OPTIONS.map((option) => (
        <PlatformOptionRow
          key={option.key}
          option={option}
          selected={value === option.key}
          disabled={disabledFor(option.key)}
          onSelect={() => onSelect(option.key)}
        />
      ))}
    </div>
  );
}
